/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ILayoutConfig, LAYOUT_TYPE } from "../../../ui/components/Layout/LayoutTypes";
import { ARROW_POSITION } from "../../../ui/components/Toolbar/Toolbar";

export const ThemeEditorLayoutConfig: ILayoutConfig = {
	root: {
		type: LAYOUT_TYPE.ROW,
		id: "layout",
		children: [
			{
				type: LAYOUT_TYPE.COLUMN,
				id: "panelLeft",
				size: "250px",
				isExpandable: true,
				defaultExpanded: true,
				children: [
					{
						type: LAYOUT_TYPE.PANEL,
						id: "outline",
						isExpandable: false,
						size: 40,
						arrowPosition: ARROW_POSITION.LEFT,
						toolbarComponent: "outlineToolbar",
						contentComponent: "outlineContent"
					}
				]
			},
			{
				type: LAYOUT_TYPE.SPLITTER,
				id: "leftSplitter"
			},
			{
				type: LAYOUT_TYPE.COLUMN,
				id: "main",
				children: [
					{
						type: LAYOUT_TYPE.PANEL,
						id: "content",
						isExpandable: false,
						toolbarComponent: "mainToolbar",
						secondaryToolbarComponent: "secondaryMainToolbar",
						contentComponent: "mainContent"
					}
				]
			},
			{
				type: LAYOUT_TYPE.SPLITTER,
				id: "rightSplitter"
			},
			{
				type: LAYOUT_TYPE.TABS,
				id: "panelRight",
				size: "250px",
				isExpandable: true,
				defaultExpanded: true,
				defaultTabIndex: 0,
				tabs: [
					{
						id: "inspector",
						icon: "mdi/tune",
						label: "Inspector",
						tooltip: "Inspector",
						contentComponent: "inspector"
					}
				]
			}
		]
	}
};
